import React, { useEffect, useState } from "react";
import PopupModal from "../../../Components/ModalComponent/PopupModal";

import { ManageApis } from "../../../AppServices/ManageApi";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../../Components/AlertBox/AlertBox";
import Loader from "../../../Components/LoaderComponent/Loader";
import InputComponent2 from "../../../Components/InputComponent/InputComponent2";
import {
  PreventNonNumeric,
  convertUtcToBrowserTimeZone,
  dataTableInitialLoader,
  emailValidation,
  formatingValue,
  handleCopy,
  preventSpecialChars,
  userValidation,
} from "../../../Functions/Utils";
import DataTable from "../../../Components/DataTable/DataTable";
import { Input } from "@arco-design/web-react";
import moment from "moment";
const InputSearch = Input.Search;
function Menulist() {
  const initaialCreatMenu = {
    menuName: "",


  };
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [createMenuData, setCreateMenuData] = useState(initaialCreatMenu);
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState('')
  const [visible, setvisible] = useState({ show: false, type: "" });
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [MenuList, setMenuList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tableLoader, setTableLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [formatedMenuList, setFormatedMenuList] = useState([]);
  const [editableRows, setEditableRows] = useState({});
  const [editingRowId, setEditingRowId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();

  let createMenuform = [
    {
      type: "text",
      name: "menuName",
      label: "Menu Name",
      regex: /[^a-zA-Z0-9\s]/g,
      max: 100,
    },
  ];

  const columns = [
    {
      title: "Menu",
      dataIndex: "menuName",
     
      render: (text, record) => (
        // //console.log(record),
        editableRows[record.id] ? (
          <input
            type={"text"}
            className={`form-control  ${formatedMenuList?.filter((itm) => itm.id == record.id)[0][
              "menuName"
            ] == "" ? "isinvalid" : ""}`}
            value={
              formatedMenuList?.filter((itm) => itm.id == record.id)[0][
              "menuName"
              ]
            }
            onChange={(e) =>
              handleInputChange(record.id, "menuName", e.target.value)
            }
            disabled={!editableRows[record.id]}

          />
        ) : (
          text
        )
      ),
      width: "400px",
    },
    {
      title: "Modified Date",
      dataIndex: "modifiedDate",
      width: "400px",
      render: (v, record) => {
        // ""
        return (<div>{convertUtcToBrowserTimeZone(record.modifiedDate)}</div>)


      },
    },
    {
      title: "Menu Id",
      dataIndex: "",
      width: "200px",
      render: (text, record) => (
        // //console.log(record),
  
     
        <button
          className="btn btn-master  px-2 font_13 py-1 mb-1 text-nowrap"
          onClick={() => handleCopy(record?.id)}
            >
              <span>

       Copy Menu Id
              </span>
      </button>
         
      ),
   
    },

    {
      title: "Action",
      dataIndex: "action",
      width: "200px",
      render: (v, record) => {
        return (
          // //console.log("sssssssssssssss", record),
          (
            <div className="d-flex justify-content-center">
              {editingRowId === record?.id ? (
                <>
                  <div className="col-12 ">
                    <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                      <button
                        className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleSave(record?.id)}
                      >
                        Save
                      </button>

                      <button
                        className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleCancel(record.id)}
                      >
                        Cancel
                      </button>
                      {/* <DeleteTwoTone /> */}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* Not in use */}
                  {/* <i
                      className="arco-icon-delete text-danger font_14 cursor-pointer ms-2"
                      onClick={() => handleDeleteMenu(record)}
                    /> */}
                  <div className="col-12 ">
                    <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                      <button
                        className="  btn px_btn btn-master py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleEdit(record?.id)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleDeleteMenu(record?.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )
        );
      },
    },
  ];

  useEffect(() => {
    getMenuList();
  }, []);

  const handleInputChange = (id, field, value) => {
    // //console.log(id, field, value);

    const updatedData = formatedMenuList.map((item) =>
      item.id === id
        ? {
          ...item,
          [field]:
            field === "actionCount"
              ? preventSpecialChars(value, 5, /[^0-9\s]/g)
              : value,
        }
        : item
    );
    // //console.log(updatedData);
    setFormatedMenuList(updatedData);
  };
  const handleSave = async (param) => {
    // //console.log(formatedMenuList.filter((itm) => itm.id == param));

    // "";
    try {
      let formateData = formatedMenuList.filter((itm) => itm.id == param).map(item => ({
        id: item?.id,
        menuName: item?.menuName,
        createdDate: new Date().toISOString()
      }));
      if (formateData[0]?.menuName !== "") {

        setIsLoading(true);
        // let reqstBody = formatedMenuList.filter((itm) => itm.id == param);
        let result = await ManageApis("post", global.EditMenu, formateData[0]);
        if (result.message === "Success") {
          setEditableRows({});
          setEditingRowId(null);

          setSelectedRows(selectedRows.filter((rowId) => rowId !== param));
          setIsLoading(false);

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Successfully Updated...!",
            isSuccess: true,
            isfalse: false,
          }));
        } else {
          setIsLoading(false);
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Somthing went wrong...!",
            isSuccess: false,
            isfalse: true,
          }));
        }
      }




    } catch (err) {
      // //console.log(err);
    }
    // You can implement the logic to save the changes here
  };

  const handleCancel = (id) => {
    const updatedEditableRows = { ...editableRows };
    delete updatedEditableRows[id];
    setEditableRows(updatedEditableRows);
    setEditingRowId(null);
    setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    setFormatedMenuList(MenuList)
  };
  const getMenuList = async () => {
    try {
      setIsLoading(true);
      let response = await ManageApis("get", global.ListingAllMenus);
      // //console.log(response);
      if (response.message === "Success") {
        setIsLoading(false);
        setMenuList(response?.response_data);
        setFormatedMenuList(response?.response_data);
      } else {
        // //console.log(response);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  const handleEdit = (id) => {
    setEditingRowId(id);
    setEditableRows((prevState) => ({
      [id]: !prevState[id], // Toggle edit mode for the clicked row
    }));
    setSelectedRows([id]);
  };

  const handleDeleteMenu = async (params) => {
    try {
      setIsLoading(true);

      let result = await ManageApis(
        "post",
        `${global.DeleteMenu}?id=${params}`
      );
      if (result.message == "Success") {
        setIsLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Menu Deleted Successfully",
          isSuccess: true,
        }));
        // call get menulist for update data here
      } else {
        setIsLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Something Went wrong",
          isfalse: true,
        }));
        // //console.log(result);
      }
    } catch (err) {
      // //console.log(err);
    }
  };

  // create menu handlechange
  const handleChange = (e, regex, max) => {
    const { name, value } = e.target;
    // ""
    // //console.log(name, value, regex, max);

    switch (name) {
      case name:
        setCreateMenuData((prevState) => ({
          ...prevState,
          [name]: regex ? formatingValue(value, max, regex) : value,
        }));
        handleError(null, [name]);
      default:
        break;
    }
  };

  const handleError = (error, input) => {
    setErrors((prevState) => ({ ...prevState, [input]: error }));
  };

  const handleAlertBoxCancel = () => {
    if (showAlert.isSuccess) {
      getMenuList();
      setShowAlert(AlertinitialValue);
    } else {
      setShowAlert(AlertinitialValue);
    }
  };

  // handle Add Menu
  const handleAddMenu = async () => {
    const validate = () => {
      let isValid = true;

      let array = Object.keys(createMenuData);
      let result = userValidation(createMenuData, array);
      // ""
      result.forEach((item) => {
        // handleError(`Please Enter the ${item.replace("_", " ")}`, item);
        handleError(`Please Enter the Menu Name`, item);
        isValid = false;
      });

      // //console.log(result);

      Object.keys(errors).forEach((key) => {
        if (errors[key]) {
          isValid = false;
          // //console.log(errors[key]);
        }
      });

      return isValid;
    };
    try {
      if (validate()) {
        setIsLoading(true);

        setShow(false);
        const reqstBody = {
          ...createMenuData,
          actionCount: parseInt(createMenuData.actionCount),
          createdDate: new Date().toISOString(),
        };
        let result = await ManageApis("post", global.CreateMenu, reqstBody);
        if (result.message == "Success") {
          // //console.log(result);
          setCreateMenuData(initaialCreatMenu);
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Menu added successfully",
            isSuccess: true,
          }));
          setIsLoading(false);
        } else {
          setCreateMenuData(initaialCreatMenu);
          setIsLoading(false);
          // //console.log(result);

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Something went wrong...!",
            isSuccess: false,
            isfalse: true,
          }));
        }
      }
    } catch (err) {
      // //console.log(err);
    }
  };
  const onChangeTable = (pagination) => {
    // "";
    // //console.log(pagination);

    const { current, pageSize } = pagination;
    // //console.log({ pageSize });
    setTableLoader(true);

    setFormatedMenuList(dataTableInitialLoader(columns));
    setTimeout(() => {
      setFormatedMenuList(
        MenuList.slice((current - 1) * pageSize, current * pageSize)
      );
      setPageSize(pageSize);
      setcurrentPage(current);
      setTableLoader(false);
    }, 2000);
  };

  const handlesearch = (value) => {
    setSearchText(formatingValue(value, 20, /[^a-zA-Z\s]/g))
    try {
      if (searchText) {
        setFormatedMenuList(() => (
          MenuList.filter((itm) => (itm?.menuName?.toLowerCase().includes(value?.toLowerCase())))
        ))
      } else {
        setFormatedMenuList(MenuList)
      }

    } catch (error) {
      // console.error("An error occurred:", error.message);
    }
  }
  return (
    <>
      {isLoading && <Loader />}
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={handleAlertBoxCancel}
      />
      <div className="p-2">
        <section className="admin_Section ">
          <div
            className={`d-flex justify-content-between align-items-center ${MenuList?.length > 0 ? "" : "d-none"
              }`}
          >
            <h3 className="text_master2 mb-0 text-uppercase  py-2 font_18 fw_600">
              Menu List
            </h3>
            <div className="  flex-column flex-md-row g-1 d-flex gap-3 justify-content-between ">
              <div className=" arco_inputsearch ">
                <InputSearch value={searchText} onChange={handlesearch} allowClear placeholder='Enter menu name' />
              </div>
              <button
                className="btn btn-master font_14 px-4"
                onClick={() => setShow(true)}
              >
                Add Menu +
              </button>
            </div>
          </div>
          <div className="custom_scroll1 h-100 mt-3 pb-5 table-responsive table_type02">
            {!MenuList?.length > 0 ? (
              <div className="d-flex  h-100">
                <div className="m-auto text-center">
                  <i className="fas fa-user-alt-slash font_18 mb-2"></i>
                  <div className="pb-2">Currently No Menu Available</div>
                  <button
                    className="btn btn-master font_14 px-4"
                    onClick={() => setShow(true)}
                  >
                    Add Menu +
                  </button>
                </div>
              </div>
            ) : (
              <DataTable
                loading={tableLoader}
                columnData={columns}
                rowData={formatedMenuList}
                current={currentPage}
                pageSize={pageSize}
                total={MenuList?.length}
                onChangeTable={onChangeTable}
              />
            )}
          </div>
        </section>
      </div>

      <PopupModal
        title="Enter Details"
        size="md"
        visible={show}
        handleClose={() => setShow(false)}
      >
        <div className="row align-items-center">
          <div className="col-12 text_m1 fw_500 d-none">Menu</div>
          <div className="col-12 pt-1 pt-sm-0 mb-3 mb-sm-0">
            <div className=" pt-2">
              <div className="data w-100">
                {createMenuform.map((itm) => (
                  <div
                    className={`${itm.hasOwnProperty("col") ? itm.col : "col-12"
                      }`}
                  >
                    <InputComponent2
                      label={itm.label}
                      name={itm.name}
                      type={itm.type}
                      value={createMenuData[itm.name]}
                      error={errors[itm.name]}
                      disabled={itm.isDisabled}
                      onchange={(e) => handleChange(e, itm?.regex, itm.max)}
                    />
                  </div>
                ))}

                {/* <select className="form-control pe-0">
                        <option>Adhaar Masking</option>
                        <option>User</option>
                      </select> */}
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-end">
              <button
                className="btn btn-master px-3 font_14"
                onClick={handleAddMenu}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </PopupModal>
    </>
  );
}

export default Menulist;
